import React from 'react';

export default function Tag() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 442.688 442.688" style={{enableBackground: "new 0 0 442.688 442.688"}}>
      <g>
        <g>
          <path d="m442.666 178.822-4.004-145.078c-.447-16.222-13.504-29.279-29.727-29.728L263.855.012c-8.475-.237-16.493 2.97-22.468 8.945L8.954 241.391c-11.924 11.924-11.924 31.325 0 43.249l149.083 149.082c11.951 11.953 31.296 11.956 43.25.001L433.721 201.29c5.915-5.916 9.176-14.106 8.945-22.468zm-66.428-38.843c-20.323 20.322-53.215 20.324-73.539 0-20.275-20.275-20.275-53.265 0-73.539 20.323-20.323 53.215-20.324 73.539 0 20.274 20.274 20.274 53.264 0 73.539z"/>
        </g>
      </g>
    </svg>
  );
}